export default "__VITE_ASSET__e00da284__"